/**
 * Shopify GA4 커스텀 추적 코드 v2
 * 
 * 추가된 기능:
 * - 퀵 카트 버튼 추적 (리스트 페이지)
 * - cart-drawer 모달 내 행동 추적
 * - 장바구니 페이지 체류시간
 * - 메인 페이지 영역별 클릭
 * - 상품 재방문 추적
 * - 구매까지 소요 시간
 * 
 * 설치방법:
 * 1. 이 파일을 Shopify Assets 폴더에 업로드
 * 2. theme.liquid </body> 위에 아래 코드 추가:
 * 
 * <script>
 * window.ShopifyGA4 = {
 *   cart: {{ cart | json }},
 *   product: {% if product %}{{ product | json }}{% else %}null{% endif %},
 *   collection: {% if collection %}{{ collection | json }}{% else %}null{% endif %},
 *   customer: {{ customer | json }},
 *   pageType: '{{ request.page_type }}',
 *   pathname: '{{ request.path }}'
 * };
 * </script>
 * {{ 'ga4-tracking-v2.js' | asset_url | script_tag }}
 */

(function() {
  'use strict';

  function waitForGtag(callback) {
    if (typeof gtag !== 'undefined') callback();
    else setTimeout(function() { waitForGtag(callback); }, 100);
  }

  var data = window.ShopifyGA4 || {};
  var cart = data.cart || { items: [], total_price: 0, token: '' };
  var product = data.product;
  var collection = data.collection;
  var pathname = data.pathname || window.location.pathname;

  function getPageType(path) {
    if (path === '/' || path === '') return 'home';
    if (path.includes('/products/')) return 'product_detail';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/cart')) return 'cart';
    if (path.includes('/checkout')) return 'checkout';
    if (path.includes('/pages/')) return 'custom_page';
    if (path.includes('/search')) return 'search';
    return 'other';
  }

  function getProductNameFromUrl(url) {
    var match = url.match(/\/products\/([^?#\/]+)/);
    return match ? match[1].replace(/-/g, ' ') : '';
  }

  waitForGtag(function() {

    // ========================================
    // 1. 장바구니 추가 추적 (퀵카트 포함)
    // ========================================
    document.addEventListener('click', function(e) {
      // 일반 장바구니 추가 버튼
      var addToCartBtn = e.target.closest('[type="submit"][name="add"], .add-to-cart, [data-add-to-cart], .product-form__submit');
      
      // 퀵 카트 버튼 (리스트 페이지)
      var quickCartBtn = e.target.closest('.quick-cart-drawer__trigger, .product-card__add-to-cart--button');

      if (!addToCartBtn && !quickCartBtn) return;

      var pageType = getPageType(pathname);
      var productName = '';
      var addMethod = 'normal';

      if (quickCartBtn) {
        addMethod = 'quick_cart';
        var productUrl = quickCartBtn.getAttribute('data-product-url') || '';
        productName = getProductNameFromUrl(productUrl);
      } else if (product) {
        productName = product.title;
      }

      gtag('event', 'add_to_cart_source', {
        source_page_type: pageType,
        source_page_url: window.location.href,
        product_id: product ? product.id : '',
        product_title: productName,
        product_price: product ? product.price / 100 : 0,
        add_method: addMethod
      });
    });

    // ========================================
    // 2. Cart Drawer 모달 추적
    // ========================================
    (function() {
      var drawerOpenTime = null;

      function checkDrawerState() {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        var observer = new MutationObserver(function() {
          var isOpen = drawer.classList.contains('is-open') || 
                      drawer.classList.contains('active') ||
                      drawer.hasAttribute('open');

          if (isOpen && !drawerOpenTime) {
            drawerOpenTime = Date.now();
            gtag('event', 'cart_drawer_opened', {
              source_page: getPageType(pathname),
              cart_item_count: cart.items ? cart.items.length : 0
            });
          } else if (!isOpen && drawerOpenTime) {
            var timeSpent = Math.round((Date.now() - drawerOpenTime) / 1000);
            gtag('event', 'cart_drawer_closed', {
              time_spent_seconds: timeSpent
            });
            drawerOpenTime = null;
          }
        });

        observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkDrawerState);
      } else {
        checkDrawerState();
      }

      // cart-drawer 내 클릭 이벤트
      document.addEventListener('click', function(e) {
        var drawer = e.target.closest('cart-drawer');
        if (!drawer) return;

        // 결제하기 버튼
        if (e.target.closest('[name="checkout"], .checkout-button, [href*="/checkout"]')) {
          var timeSpent = drawerOpenTime ? Math.round((Date.now() - drawerOpenTime) / 1000) : 0;
          gtag('event', 'cart_drawer_checkout_clicked', {
            time_in_drawer_seconds: timeSpent
          });
        }

        // 삭제 버튼
        if (e.target.closest('cart-remove-button, [data-remove], .remove-item')) {
          gtag('event', 'cart_drawer_item_removed', {
            location: 'cart_drawer'
          });
        }
      });

      // cart-drawer 내 수량 변경
      document.addEventListener('change', function(e) {
        var drawer = e.target.closest('cart-drawer');
        if (!drawer) return;

        if (e.target.matches('input[type="number"], .quantity-input')) {
          gtag('event', 'cart_drawer_quantity_changed', {
            new_quantity: parseInt(e.target.value) || 0
          });
        }
      });
    })();

    // ========================================
    // 3. 장바구니 페이지 추적
    // ========================================
    if (pathname.includes('/cart')) {
      var cartStartTime = Date.now();
      var isInternalNavigation = false;
      var cartItems = cart.items || [];
      var cartTotal = (cart.total_price || 0) / 100;
      var cartProductIds = cartItems.map(function(i) { return i.product_id; }).sort().join(',');

      // 재방문 체크
      var previousProductIds = sessionStorage.getItem('cart_product_ids');
      var visitCount = parseInt(sessionStorage.getItem('cart_visit_count') || '0') + 1;

      if (previousProductIds && previousProductIds === cartProductIds && visitCount > 1) {
        gtag('event', 'cart_revisit_same_items', {
          visit_count: visitCount,
          cart_item_count: cartItems.length,
          cart_total: cartTotal
        });
      }

      sessionStorage.setItem('cart_product_ids', cartProductIds);
      sessionStorage.setItem('cart_visit_count', visitCount.toString());
      sessionStorage.setItem('cart_enter_time', Date.now().toString());

      // 내부 링크 클릭
      document.addEventListener('click', function(e) {
        var link = e.target.closest('a');
        if (!link || !link.href || !link.href.includes(window.location.hostname)) return;

        isInternalNavigation = true;
        var destPath = new URL(link.href).pathname;
        var timeSpent = Math.round((Date.now() - cartStartTime) / 1000);

        gtag('event', 'cart_exit_internal', {
          exit_destination: link.href,
          exit_destination_type: getPageType(destPath),
          cart_item_count: cartItems.length,
          cart_total: cartTotal,
          time_on_cart_seconds: timeSpent
        });
      });

      // 뒤로가기
      window.addEventListener('popstate', function() {
        isInternalNavigation = true;
        gtag('event', 'cart_exit_back', {
          cart_item_count: cartItems.length,
          cart_total: cartTotal,
          time_on_cart_seconds: Math.round((Date.now() - cartStartTime) / 1000)
        });
      });

      // 탭 종료
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden' && !isInternalNavigation) {
          var timeSpent = Math.round((Date.now() - cartStartTime) / 1000);
          gtag('event', 'cart_exit_close', {
            cart_item_count: cartItems.length,
            cart_total: cartTotal,
            time_on_cart_seconds: timeSpent
          });

          gtag('event', 'cart_page_engagement', {
            time_spent_seconds: timeSpent,
            time_category: timeSpent < 10 ? 'quick_glance' : timeSpent < 30 ? 'browsing' : timeSpent < 60 ? 'considering' : 'highly_engaged'
          });
        }
      });

      // 수량 변경
      document.addEventListener('change', function(e) {
        var qtyInput = e.target.closest('input[name="updates[]"], input[type="number"], .quantity-input');
        if (!qtyInput) return;
        gtag('event', 'cart_quantity_changed', {
          new_quantity: parseInt(qtyInput.value),
          is_removal: parseInt(qtyInput.value) === 0
        });
      });

      // 삭제 버튼
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-remove], .remove, .cart-remove, a[href*="/cart/change"]')) {
          gtag('event', 'cart_item_removed', { removal_method: 'button_click' });
        }
      });
    }

    // ========================================
    // 4. 메인 페이지 영역별 클릭 추적
    // ========================================
    if (pathname === '/' || pathname === '') {
      document.addEventListener('click', function(e) {
        var link = e.target.closest('a');
        if (!link) return;

        var section = e.target.closest('section, [class*="section"]');
        var sectionClass = section ? section.className : '';
        var sectionId = section ? section.id : '';
        
        var clickArea = 'other';
        
        // 배너 영역
        if (e.target.closest('[class*="banner"], [class*="hero"], [class*="slide"], [class*="carousel"]')) {
          clickArea = 'main_banner';
        }
        // 베스트/추천 영역
        else if (e.target.closest('[class*="best"], [class*="featured"], [class*="recommend"], [class*="popular"]')) {
          clickArea = 'best_products';
        }
        // 컬렉션 영역
        else if (link.href.includes('/collections/')) {
          clickArea = 'collection_link';
        }
        // 상품 링크
        else if (link.href.includes('/products/')) {
          clickArea = 'product_link';
        }

        var clickedProduct = link.href.includes('/products/') ? getProductNameFromUrl(link.href) : '';

        gtag('event', 'home_click', {
          click_area: clickArea,
          section_id: sectionId,
          section_class: sectionClass.substring(0, 100),
          clicked_url: link.href,
          clicked_product: clickedProduct
        });
      });
    }

    // ========================================
    // 5. 상품 상세 페이지 추적
    // ========================================
    if (pathname.includes('/products/') && product) {
      var startTime = Date.now();
      var maxScrollDepth = 0;
      var hasInteracted = false;

      // 재방문 체크
      var viewedProducts = JSON.parse(sessionStorage.getItem('viewed_products') || '{}');
      var productVisitCount = (viewedProducts[product.id] || 0) + 1;
      viewedProducts[product.id] = productVisitCount;
      sessionStorage.setItem('viewed_products', JSON.stringify(viewedProducts));

      if (productVisitCount > 1) {
        gtag('event', 'product_revisit', {
          product_id: product.id,
          product_title: product.title,
          visit_count: productVisitCount
        });
      }

      window.addEventListener('scroll', function() {
        var scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
        if (scrollPercent > maxScrollDepth) maxScrollDepth = scrollPercent;
        hasInteracted = true;
      });

      document.addEventListener('click', function() { hasInteracted = true; });

      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
          var timeSpent = Math.round((Date.now() - startTime) / 1000);
          gtag('event', 'product_page_engagement', {
            product_id: product.id,
            product_title: product.title,
            product_price: product.price / 100,
            time_spent_seconds: timeSpent,
            max_scroll_depth: maxScrollDepth,
            had_interaction: hasInteracted,
            time_category: timeSpent < 10 ? 'quick_glance' : timeSpent < 30 ? 'browsing' : timeSpent < 60 ? 'interested' : 'highly_engaged'
          });
        }
      });

      // 이미지 클릭
      document.addEventListener('click', function(e) {
        if (e.target.closest('.product__media, .product-image, [data-product-image]')) {
          gtag('event', 'product_image_interaction', {
            product_id: product.id,
            product_title: product.title
          });
        }
      });

      // 옵션 선택
      document.addEventListener('change', function(e) {
        var optionSelect = e.target.closest('select[name*="option"], input[name*="option"]');
        if (optionSelect) {
          gtag('event', 'product_option_selected', {
            product_id: product.id,
            option_value: optionSelect.value
          });
        }
      });
    }

    // ========================================
    // 6. 결제 페이지 추적
    // ========================================
    if (pathname.includes('/checkout')) {
      var cartVisitCount = parseInt(sessionStorage.getItem('cart_visit_count') || '0');
      var stepStartTime = Date.now();

      function detectCheckoutStep() {
        var url = window.location.href;
        if (url.includes('/information') || url.includes('step=contact')) return 'information';
        if (url.includes('/shipping') || url.includes('step=shipping')) return 'shipping';
        if (url.includes('/payment') || url.includes('step=payment')) return 'payment';
        if (url.includes('/thank_you') || url.includes('/orders/')) return 'complete';
        return 'checkout_start';
      }

      var currentStep = detectCheckoutStep();

      if (currentStep !== 'complete') {
        gtag('event', 'checkout_step_viewed', {
          checkout_step: currentStep,
          cart_visit_count: cartVisitCount
        });
      }

      // URL 변경 감지
      var lastUrl = window.location.href;
      new MutationObserver(function() {
        if (window.location.href !== lastUrl) {
          var previousStep = currentStep;
          var timeOnStep = Math.round((Date.now() - stepStartTime) / 1000);

          currentStep = detectCheckoutStep();
          lastUrl = window.location.href;
          stepStartTime = Date.now();

          gtag('event', 'checkout_step_completed', {
            completed_step: previousStep,
            next_step: currentStep,
            time_on_step_seconds: timeOnStep
          });

          if (currentStep !== 'complete') {
            gtag('event', 'checkout_step_viewed', { checkout_step: currentStep });
          }
        }
      }).observe(document.body, { subtree: true, childList: true });

      // 결제 이탈
      var isNavigatingAway = false;
      document.addEventListener('click', function(e) {
        var link = e.target.closest('a');
        if (link && !link.href.includes('/checkout')) {
          isNavigatingAway = true;
          gtag('event', 'checkout_exit', {
            exit_from_step: currentStep,
            exit_destination: link.href,
            time_on_step_seconds: Math.round((Date.now() - stepStartTime) / 1000)
          });
        }
      });

      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden' && !isNavigatingAway && currentStep !== 'complete') {
          gtag('event', 'checkout_abandon', {
            abandon_at_step: currentStep,
            time_on_step_seconds: Math.round((Date.now() - stepStartTime) / 1000)
          });
        }
      });

      // 결제 완료
      if (currentStep === 'complete') {
        var cartEnterTime = parseInt(sessionStorage.getItem('cart_enter_time') || '0');
        var timeToPurchase = cartEnterTime ? Math.round((Date.now() - cartEnterTime) / 1000) : 0;

        gtag('event', 'purchase_completed', {
          cart_visit_count_before_purchase: cartVisitCount,
          time_to_purchase_seconds: timeToPurchase,
          time_to_purchase_category: timeToPurchase < 60 ? 'instant' : timeToPurchase < 300 ? 'quick' : timeToPurchase < 900 ? 'considered' : 'delayed'
        });

        sessionStorage.removeItem('cart_product_ids');
        sessionStorage.removeItem('cart_visit_count');
        sessionStorage.removeItem('cart_enter_time');
        sessionStorage.removeItem('viewed_products');
      }
    }

    // ========================================
    // 7. 위시리스트 추적
    // ========================================
    document.addEventListener('click', function(e) {
      var wishlistBtn = e.target.closest('.wishlist-btn, [data-wishlist], .add-to-wishlist, .swym-button, [class*="wishlist"], [class*="favorite"]');
      if (!wishlistBtn) return;

      gtag('event', 'add_to_wishlist', {
        product_id: product ? product.id : 'unknown',
        product_title: product ? product.title : '',
        source_page: getPageType(pathname)
      });
    });

    // ========================================
    // 8. 검색 추적
    // ========================================
    document.addEventListener('submit', function(e) {
      var searchForm = e.target.closest('form[action="/search"], .search-form');
      if (!searchForm) return;

      var searchInput = searchForm.querySelector('input[name="q"], input[type="search"]');
      if (searchInput && searchInput.value) {
        gtag('event', 'search_performed', { search_term: searchInput.value });
      }
    });

    if (pathname.includes('/search')) {
      var searchTerm = new URLSearchParams(window.location.search).get('q');
      var noResults = document.querySelector('.no-results, .search-no-results, [class*="no-result"]');
      
      if (noResults) {
        gtag('event', 'search_no_results', { search_term: searchTerm });
      }

      document.addEventListener('click', function(e) {
        var productLink = e.target.closest('a[href*="/products/"]');
        if (productLink) {
          gtag('event', 'search_result_clicked', {
            search_term: searchTerm,
            clicked_product: getProductNameFromUrl(productLink.href)
          });
        }
      });
    }

    // ========================================
    // 9. 컬렉션 추적
    // ========================================
    if (pathname.includes('/collections/') && collection) {
      gtag('event', 'collection_viewed', {
        collection_name: collection.title,
        collection_url: window.location.href
      });

      document.addEventListener('change', function(e) {
        var filterEl = e.target.closest('select[name*="filter"], input[name*="filter"]');
        if (filterEl) {
          gtag('event', 'collection_filter_used', {
            collection_name: collection.title,
            filter_value: filterEl.value
          });
        }

        var sortEl = e.target.closest('select[name="sort_by"]');
        if (sortEl) {
          gtag('event', 'collection_sort_changed', {
            collection_name: collection.title,
            sort_by: sortEl.value
          });
        }
      });
    }

    // ========================================
    // 10. 페이지 이탈 추적 (퍼널용)
    // ========================================
    (function() {
      var pageStartTime = Date.now();
      var pageType = getPageType(pathname);
      var hasEngaged = false;

      window.addEventListener('scroll', function() { hasEngaged = true; }, { once: true });
      document.addEventListener('click', function() { hasEngaged = true; }, { once: true });

      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
          var timeSpent = Math.round((Date.now() - pageStartTime) / 1000);
          gtag('event', 'page_exit', {
            page_type: pageType,
            time_spent_seconds: timeSpent,
            had_engagement: hasEngaged,
            exit_type: hasEngaged ? 'engaged_exit' : 'bounce'
          });
        }
      });
    })();

  });
})();